<style lang="scss" scoped="">
  $table-background-color: #dfe6ec;
  $table-background-color-tint: #eee;
  .product-detail-list {
    margin: 20px 0;
    table-layout: fixed;
    /*margin-top: 20px;*/
    text-align: center;
    border-collapse: collapse;
    font-size: 12px;

    > tbody > tr > td {
      padding: 5px;
      border: 1px solid $table-background-color;
    }

    .t-head {
      background: #eaf2f8;
      color: #1f2d3d;
      font-weight: bold;
    }

    &.is-top {
      > tbody > tr > td {
        border-bottom: 0;
      }
    }

    &.is-tint {
      > tbody > tr > td {
        border: 1px solid #d6d6d6;
      }

      .t-head {
        background: $table-background-color-tint;
      }

      &.is-top {
        > tbody > tr > td {
          border-bottom: 0;
        }
      }
    }
  }

  .bg-white {
    background: #fff;
  }

  .bg-red {
    background: #f70f0f;
  }

  .color-red {
    color: red;
  }

  .page-main-body {
    .oms-row {
      margin-bottom: 5px;
    }
  }

  .goods-histories {
    border: 1px solid #dfe6ec;
    border-top: 0;
    padding: 10px 20px;
    margin-bottom: 10px;

    h3 {
      margin: 0;
      font-weight: 500;
      font-size: 18px;
      text-align: center;
    }

    .h-item {
      padding-bottom: 20px;
    }
  }
</style>
<template>
  <div>
    <div>
      <div v-for="item in goodsDetails" :key="item.id">
        <table class="product-detail-list" width="100%">
          <tbody>
          <tr>
            <td colspan="1" class="t-head">名称</td>
            <td colspan="3">
              <div>
                {{item.goodsName}}
              </div>
              <div class="f-grey">
                {{ item.specification }}
              </div>
            </td>
            <td colspan="1" class="t-head">生产厂商</td>
            <td colspan="3">{{item.factoryName}}</td>
          </tr>
          <tr>
            <td colspan="2" class="t-head">批号</td>
            <td colspan="2" class="t-head">生产日期</td>
            <td colspan="2" class="t-head">有效期</td>
            <td colspan="2" class="t-head">发货数量</td>
          </tr>
          <tr v-for="batchNumber in item.batchNumbers" :key="batchNumber.id"
              v-if="item.batchNumbers && item.batchNumbers.length > 0">
            <td colspan="2">{{ batchNumber.batchNumber }}</td>
            <td colspan="2">{{ batchNumber.productionDate | date }}</td>
            <td colspan="2">{{ batchNumber.expirationDate | date }}</td>
            <td colspan="2">{{batchNumber.aggregateQuantity || ''}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    props: {
      goodsList: {
        required: true,
        type: Array,
        default: function () {
          return [];
        }
      }
    },
    computed: {
      goodsDetails() {
        if (!this.goodsList || !this.goodsList.length) return [];
        let obj = {};
        this.goodsList.forEach(i => {
          obj[i.goodsId] = {
            goodsName: i.goodsName,
            specification: i.specification,
            factoryName: i.factoryName
          };
        });
        Object.keys(obj).forEach(i => {
          let batchNumbers = this.goodsList.filter(f => f.goodsId === i);
          obj[i].batchNumbers = batchNumbers.map(m => ({
            batchNumber: m.batchNumber,
            productionDate: m.productionDate,
            expirationDate: m.expirationDate,
            aggregateQuantity: m.aggregateQuantity
          }));
        });
        return Object.keys(obj).map(m => obj[m]);
      }
    }
  };
</script>
